module.exports = __webpack_public_path__ + "img/2_B.e45f0cee.png";